module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }